import { IconProps } from '../../types';

const FlagIcon = ({ title = 'Video', className }: IconProps) => (
    <svg className={className} width="24" height="24" viewBox="0 -960 960 960" fill="currentColor">
        <title>{title}</title>
        <path d="M200-80v-760h640l-80 200 80 200H280v360h-80Zm80-440h442l-48-120 48-120H280v240Zm0 0v-240 240Z" />
    </svg>
);

export default FlagIcon;
